import { useEffect, useState, useRef } from "react";
import { FaTimes, FaPlus, FaMinus, FaRedo, FaInfoCircle, FaEdit, FaEye, FaRegCommentDots, FaTrashAlt, FaCheck } from "react-icons/fa";
import pathconfig from "../../pathconfig.json";
import axios from "axios";
import { toastError, toastSuccess } from "../toaster";
import image from "../../images/icons/image.png";
import skip from "../../images/icons/skip.png";
import create from "../../images/icons/create.png";
import validate from "../../images/icons/Validate_v2_dark.png";
import create_v2 from "../../images/icons/Create_v2.png";
import validate_v2 from "../../images/icons/Validate_v2.png";
import skip_v2 from "../../images/icons/Skip_v2.png";
import EditIcon from "../../images/icons/edit.png";
import VerifiedIcon from "../../images/icons/verified.png";
import moment from "moment";
import NodataFound from "../nodata";
import packjson from "../../../package.json";
import { useAppContextProvider } from "../../contextapi";
import { AiOutlineSync } from "react-icons/ai";
import { updateAltTextWithTracking } from "../editor/index";

const ImagelistTab = (props) => {
  const [fileList, setFileList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [imgPathValue, setImgPathValue] = useState({});
  const [imgZoom, setImgZoom] = useState(1);
  const [texData, setTexData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [loadingItemId, setLoadingItemId] = useState(null);
  const [altText, setAltText] = useState({ type: "", short: "", long: "", shortExists: false, longExists: false });
  const [altTextMap, setAltTextMap] = useState({});
  const [modalMode, setModalMode] = useState("preview");
  const [selectedAction, setSelectedAction] = useState("");
  const [validateComment, setValidateComment] = useState("");
  const [isCommentEditing, setIsCommentEditing] = useState(false);
  const [filterAction, setFilterAction] = useState("all");
  const { highlightFile, onHighlightDone } = props;
  const { userProfile, fullData, setSidebarClose, viewDoc, setLineFocus, alttextEnabled } = useAppContextProvider();

  // Derived state for simpler conditional rendering
  const isEditing = modalMode === "edit";
  const [editAltText, setEditAltText] = useState({
    type: "",
    short: "",
    long: "",
  });
  const rowRefs = useRef({});
  const altTextMapRef = useRef({});

  const currentType = isEditing ? editAltText.type : altText.type;

  // const fileInputRef = useRef(null);
  const modalCloseBtnRef = useRef(null);

  // CSS Loader Component
  const CSSLoader = () => (
    <span className="cssLoader"></span>
  );

  // Function to find the line in TeX that contains reference to this image
  const findImageLineInTeX = () => {
    if (!fullData?.Content || !imgPathValue?.name) {
      console.warn('Missing content or image name');
      return null;
    }

    const imageName = imgPathValue.name.split('.')[0]; // Get name without extension
    const content = fullData.Content;
    const lines = content.split('\n');

    // Search for line containing image reference (common LaTeX patterns)
    // Patterns like: \includegraphics{filename}, \incg{filename}, \graphic{filename}, etc.
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      // Check for common LaTeX image inclusion commands
      if (
        (line.includes('\\includegraphics') || 
         line.includes('\\incg') || 
         line.includes('\\graphic') ||
         line.includes('\\img')) &&
        line.includes(imageName)
      ) {
        return {
          line: i + 1, // Line numbers are 1-indexed
          content: line.trim()
        };
      }
    }

    return null;
  };

  // Handler to navigate to the TeX source and focus on the image reference
  const handleNavigateToTeX = () => {
    const lineInfo = findImageLineInTeX();
    
    if (lineInfo) {
      // Close the modal
      setShowModal(false);
      
      // Focus on the line in the editor
      setLineFocus({
        line: lineInfo.line,
        imageName: imgPathValue.name
      });
      
      // setTimeout(() => {
      //   toastSuccess(`Navigated to TeX line ${lineInfo.line}`);
      // }, 300);
    } else {
      toastError('Could not find image reference in TeX source');
    }
  };
  useEffect(() => {
    if (showModal && modalCloseBtnRef.current) {
      modalCloseBtnRef.current.focus();
    }
    if (!showModal) {
      setModalMode("preview");
    }
  }, [showModal]);

  const closeBtnRef = useRef(null);

  //testing
  const [folderPath, setFolderPath] = useState("");
  useEffect(() => {
    if (fullData) {
      setTexData(fullData);
      const regex = /(?<!.)\\graphicspath\{\{([^}]*)\}\}/;
      const match = fullData.Content.match(regex);
      if (match) {
        const path = match[1];
        let changePath = path.replace(/\/$/, "");
        // getFile_details(changePath)
        setFolderPath(changePath);
        getImage_details(changePath);
      } else {
        toastError("No graphicPath found.");
        return;
      }
    }
  }, [fullData]);

  // useEffect(() => {
  //     if (!fullData?.Content) return;

  //     const parsed = parseLatexAltText(fullData.Content);

  //     const hasBackendData =
  //         props.altTextContent &&
  //         Object.keys(props.altTextContent).length > 0;

  //     if (hasBackendData) {
  //         setAltTextMap(props.altTextContent);
  //     } else {
  //         setAltTextMap(parsed);
  //         props.setAltTextContent(parsed);
  //     }

  // }, [fullData, props.altTextContent]);

  useEffect(() => {
    if (!fullData?.Content) return;

    const parsed = parseLatexAltText(fullData.Content);

    const hasBackendData =
      props.altTextContent && Object.keys(props.altTextContent).length > 0;

    let baseData = hasBackendData ? { ...props.altTextContent } : { ...parsed };

    if (userProfile?.role === "Master Copier") {
      Object.keys(baseData).forEach((fileKey) => {
        const item = baseData[fileKey];
        if (item?.actionBtn) return;
        const defaultAction = item?.isEdited === true ? "validate" : "skip";
        baseData[fileKey] = {
          ...item,
          actionBtn: defaultAction,
        };
      });
    }
    setAltTextMap(baseData);
    // Keep ref in sync with latest altTextMap state
    altTextMapRef.current = baseData;
    // Persist computed defaults into global state
    props.setAltTextContent(baseData);
  }, [fullData]);
  // useEffect(() => {
  //   if (props.altTextContent) {
  //     setAltTextMap(props.altTextContent);
  //   }
  // }, [props.altTextContent]);

  // I am scrolling and highlight when parent requests a specific file if needed praveen please change the highlight file prop to file name instead of path as path can be long and complex and file name is enough to identify the row in the table and scroll to it. Currently I am doing some string manipulation to get file name from path which can be avoided if we directly send file name in highlight file prop from parent component. Please let me know if you want me to change it or I will keep it as it is. - Praveen
  useEffect(() => {
    if (highlightFile) {
      const el = rowRefs.current[highlightFile];
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        // call back after a short delay so layout can clear state
        // setTimeout(() => {
        //   if (onHighlightDone) onHighlightDone();
        // }, 2000);
      } else if (onHighlightDone) {
        onHighlightDone();
      }
    }
  }, [highlightFile, onHighlightDone, fileList]);
  useEffect(() => {
    if (props.leftsidebarvalue === "image" && closeBtnRef.current) {
      closeBtnRef.current.focus();
    }
  }, [props.leftsidebarvalue]);

  useEffect(() => {
    if (!showModal) return;
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setShowModal(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [showModal]);

  const getFile_details = async (link, name) => {
    // console.log('<<<`name`>>>', name);

    try {
      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_image_list}`;
      const data = { file_path: link, file_name: name };
      const response = await axios.post(url, data);
      // setFileList(response.data.Images);
      setImgPathValue(response.data.Images?.[0]);
      setLoader(false);
      // console.log(response.data.Images);
    } catch (error) {
      console.log(error);
      toastError(error.message);
      setLoader(false);
    }
  };

  const getImage_details = async (link) => {
    try {
      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_image_details}`;
      const data = { file_path: link };
      const response = await axios.post(url, data);
      setFileList(response.data.Files);
      console.log(response.data.Files);
    } catch (error) {
      console.log(error);
      // toastError(error.message); //Commenting it for now to give production
    }
  };

  const openModal = async (val, mode = "preview") => {
    // Prevent multiple calls if already loading
    if (isImageLoading || loadingItemId === val.name) {
      return;
    }

    setIsImageLoading(true);
    setLoadingItemId(val.name);

    try {
      setLoader(true);
      setImgZoom(1);
      setImgPathValue({});

      // await getUpdatedAltText( viewDoc); // Ensure we have the latest alt text data before opening modal

        getUpdatedAltText(viewDoc);
      

      // if (!freshRanges) {
      //   toastError("Alt text not found in document. Please refresh.");
      //   return;
      // }

      // Use ref to get latest altTextMap synchronously (not state)
      const alt = altTextMapRef.current[val.name];

      if (alt) {
        setAltText({
          type: {
            shortType: alt.short?.type?.toLowerCase() || "",
            longType: alt.long?.type?.toLowerCase() || ""
          },
          short: alt.short?.value || "",
          long: alt.long?.value || "",
          shortExists: alt.short != null,
          longExists: alt.long != null,
        });
      }

      // Explicitly set the mode
      setModalMode(mode);
      // Auto-select action based on isEdited (only for Master Copier)
      if (isMC) {
        if (alt?.actionBtn) {
          // User already selected before
          setSelectedAction(alt.actionBtn);
        } else if (alt?.isEdited === true) {
          setSelectedAction("validate");
        } else {
          setSelectedAction("skip");
        }
        // Restore any previously saved comment for this image.
        // If a comment already exists -> view mode (Edit/Delete),
        // otherwise start in edit mode (textarea + Cancel/Save).
        const savedComment = alt?.comment || "";
        setValidateComment(savedComment);
        setIsCommentEditing(!savedComment);
      }
      //              if (alt?.actionBtn) {
      //         // Already selected previously → respect it
      //         setSelectedAction(alt.actionBtn);
      //     } else {
      //         // Compute default from isEdited
      //         const defaultAction =
      //             alt?.isEdited === true ? "validate" : "skip";

      //         setSelectedAction(defaultAction);

      //         // IMPORTANT: Persist default into altTextContent
      //         props.setAltTextContent(prev => ({
      //             ...prev,
      //             [fileName]: {
      //                 ...prev[fileName],
      //                 actionBtn: defaultAction
      //             }
      //         }));
      //     }
      // }
      // Always initialize edit inputs so fields are editable in the popup
      setEditAltText({
        type:
          alt?.short?.type?.toLowerCase() ||
          alt?.long?.type?.toLowerCase() ||
          "",
        short: alt?.short?.value || "",
        long: alt?.long?.value || "",
      });

      await getFile_details(folderPath, val.name);
      // setImgPathValue(val);
      setShowModal(true);
    } catch (error) {
      console.log(error);
      toastError("Error viewing image");
    } finally {
      setIsImageLoading(false);
      setLoadingItemId(null);
    }
  };

  const handleZoom = (type) => {
    try {
      if (type === "plus") {
        setImgZoom((prev) => Math.min(prev + 0.25, 3)); // Max zoom 3x
      } else {
        setImgZoom((prev) => Math.max(prev - 0.25, 0.5)); // Min zoom 0.5x
      }
    } catch (error) {
      console.log(error);
      toastError("Error adjusting zoom");
    }
  };

  const handleResetZoom = () => {
    setImgZoom(1);
  };

  // ---------- Helper: Read balanced braces ----------
  const readBalanced = (str, start) => {
    if (str[start] !== "{") return null;

    let depth = 0;
    let i = start;

    while (i < str.length) {
      if (str[i] === "{") depth++;
      else if (str[i] === "}") depth--;

      if (depth === 0) {
        return {
          value: str.slice(start + 1, i),
          from: start + 1,
          to: i,
          endIndex: i,
        };
      }
      i++;
    }
    return null;
  };


  // ---------- Main Parser ----------
  const parseLatexAltText = (latex) => {
    const result = {};
    const fileOccurrences = {};

    const beginBlockRegex =
      /^(?!\s*%).*\\begin\{(figure\*?|sidewaysfigure\*?)\}[\s\S]*?\\end\{\1\}/gm;

    // const inlineFigureRegex = /\\inlinefigure\s*\{(?:[^{}]|\{[^{}]*\})*\}/g;
    const inlineFigureRegex = /\\inlinefigure\s*\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/gs;

    const processBlock = (block, blockStartIndex) => {
      let short = null;
      let long = null;
      let fileName = null;

      let cursor = 0;

      while ((cursor = block.indexOf("\\alttext", cursor)) !== -1) {
        const typeStart = block.indexOf("{", cursor);
        const typeObj = readBalanced(block, typeStart);

        const variantObj = typeObj && readBalanced(block, typeObj.endIndex + 1);

        const textObj =
          variantObj && readBalanced(block, variantObj.endIndex + 1);

        if (!textObj) break;

        const type = typeObj.value.trim();
        const variant = variantObj.value.trim().toLowerCase();

        const absoluteFrom = blockStartIndex + textObj.from;
        const absoluteTo = blockStartIndex + textObj.to;

        if (variant === "short") {
          short = {
            type,
            value: textObj.value.trim(),
            from: absoluteFrom,
            to: absoluteTo,
          };
        }

        if (variant === "long") {
          long = {
            type,
            value: textObj.value.trim(),
            from: absoluteFrom,
            to: absoluteTo,
          };
        }

        cursor = textObj.endIndex + 1;
      }


      // ---------- Extract image file ----------
      const incIndex = block.indexOf("\\includegraphics");

      if (incIndex !== -1) {
        const braceStart = block.indexOf("{", incIndex);
        const fileObj = readBalanced(block, braceStart);

        if (fileObj) {
          fileName = fileObj.value.trim();

          // Add .pdf if extension is missing
          if (!/\.[a-zA-Z0-9]+$/.test(fileName)) {
            fileName += ".pdf";
          }
        }
      }

      if (fileName) {
        const lineNumber = latex.slice(0, blockStartIndex).split("\n").length;

        if (!fileOccurrences[fileName]) {
          fileOccurrences[fileName] = [];
        }

        fileOccurrences[fileName].push(lineNumber);

        result[fileName] = { short, long };
      }
    };

    // 🔹 SAFE: iterate begin blocks with exec
    let match;
    while ((match = beginBlockRegex.exec(latex)) !== null) {
      const block = match[0];
      const blockStartIndex = match.index;
      processBlock(block, blockStartIndex);
    }

    // 🔹 SAFE: iterate inline blocks with exec
    while ((match = inlineFigureRegex.exec(latex)) !== null) {
      const block = match[0];
      const blockStartIndex = match.index;
      processBlock(block, blockStartIndex);
    }

    return result;
  };

  const handleFileReupload = (e) => {
    setLoader(true);
    try {
      var formdata = new FormData();
      const oversizedFiles = [];
      const maxFileSize = 40 * 1024 * 1024; // 40MB in bytes
      const validFiles = [];

      // Get the list of files from local folder
      const localFiles = fileList.map((file) => file.name);

      // Process each selected file
      for (const file of e.target.files) {
        if (file.size > maxFileSize) {
          oversizedFiles.push(file.name);
        } else {
          // If file exists in local folder, use that name instead
          const existingFile = localFiles.find(
            (localFile) =>
              localFile.toLowerCase().split(".")[0] ===
              file.name.toLowerCase().split(".")[0],
          );

          if (existingFile) {
            // Create new file object with existing name
            const renamedFile = new File([file], existingFile, {
              type: file.type,
              lastModified: file.lastModified,
            });
            validFiles.push(renamedFile);
          } else {
            validFiles.push(file);
          }
        }
      }

      validFiles.forEach((file) => formdata.append("files", file));

      if (oversizedFiles.length > 0) {
        toastError(
          `File size should be less than 40 MB: ${oversizedFiles.join(", ")} `,
        );
        setLoader(false);
        if (validFiles.length === 0) {
          e.target.value = null;
          return;
        }
      }

      const regex = /(?<!.)\\graphicspath\{\{([^}]*)\}\}/;
      const match = texData.Content.match(regex);
      if (match) {
        const path = match[1];
        formdata.append("path", path);
      } else {
        toastError("No graphicPath found.");
        return;
      }

      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].figureAttachment}`;
      axios
        .post(url, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success === true) {
            toastSuccess(`${response.data.message}`);
            setLoader(false);
            props.getTrigger(true);
          }
        })
        .catch((error) => {
          console.log(error);
          toastError(error.message);
          setLoader(false);
        });
    } catch (error) {
      console.log(error);
      toastError("Error uploading file");
      setLoader(false);
    }
    e.target.value = null;
  };

  const handleSingleFileReplace = (e, fileName) => {
    setLoader(true);
    try {
      var formdata = new FormData();
      const file = e.target.files[0];
      const maxFileSize = 40 * 1024 * 1024;

      if (file.size > maxFileSize) {
        toastError(`File size should be less than 40 MB`);
        setLoader(false);
        return;
      }

      if (!file.name.endsWith(".pdf")) {
        // Check for .pdf format
        toastError(
          `Invalid file format: ${file.name}. Only .pdf files are allowed.`,
        );
        setLoader(false);
        e.target.value = null; // Clear the input
        return;
      }

      // Create new File object with the name from the row
      const renamedFile = new File([file], fileName, {
        type: file.type,
        lastModified: file.lastModified,
      });

      formdata.append("files", renamedFile);

      const regex = /(?<!.)\\graphicspath\{\{([^}]*)\}\}/;
      const match = texData.Content.match(regex);
      if (match) {
        const path = match[1];
        formdata.append("path", path);
        formdata.append("replaceFile", fileName);
      } else {
        toastError("No graphicPath found.");
        return;
      }

      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].figureAttachment}`;

      axios
        .post(url, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success === true) {
            toastSuccess(`${response.data.message}`);
            setLoader(false);
            props.getTrigger(true);
          }
        })
        .catch((error) => {
          console.log(error);
          toastError(error.message);
          setLoader(false);
        });
    } catch (error) {
      console.log(error);
      toastError("Error replacing file");
      setLoader(false);
    }
    e.target.value = null;
  };

  const openPdfInNewTab = () => {
    if (!folderPath || !imgPathValue?.name) return;

    const baseUrl = pathconfig[packjson.environment].baseUrl;
    const viewPdfPath = pathconfig[packjson.environment].viewFigurePDF;

    const url =
      `${baseUrl}${viewPdfPath}` +
      `?file_path=${encodeURIComponent(folderPath)}` +
      `&file_name=${encodeURIComponent(imgPathValue.name)}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };

  const toggleEdit = () => {
    setEditAltText(altText);
    setModalMode("edit");
  };

  const handleSaveAlt = () => {
    try {
      if (!imgPathValue?.name) return;

      const fileName = imgPathValue.name;
      let currentMap = { ...altTextMap };
      let alt = currentMap[fileName];

      const shortMeta = alt?.short;
      const longMeta = alt?.long;

      const shortChanged = shortMeta && editAltText.short !== shortMeta.value;
      const longChanged = longMeta && editAltText.long !== longMeta.value;

      // Helper to apply the long text edit (called after short edit settles, or immediately if only long changed)
      const applyLongEdit = () => {
        // Re-read positions from the latest editor state after short edit
        const freshMap = shortChanged ? parseLatexAltText(viewDoc.state.doc.toString()) : currentMap;
        const freshAlt = freshMap[fileName] || alt;
        const freshLongMeta = freshAlt?.long || longMeta;

        updateAltTextWithTracking({
          from: freshLongMeta.from,
          to: freshLongMeta.to,
          oldValue: freshLongMeta.value,
          newValue: editAltText.long,
          altTextKey: `${fileName}::long`,
          onAfterUpdate: (updatedDoc) => {
            const updatedMap = parseLatexAltText(updatedDoc);
            setAltTextMap(updatedMap);
            altTextMapRef.current = updatedMap;
          },
        });
      };

      // SHORT - process first
      if (shortChanged) {
        updateAltTextWithTracking({
          from: shortMeta.from,
          to: shortMeta.to,
          oldValue: shortMeta.value,
          newValue: editAltText.short,
          altTextKey: `${fileName}::short`,
          onAfterUpdate: (updatedDoc) => {
            currentMap = parseLatexAltText(updatedDoc);
            setAltTextMap(currentMap);
            altTextMapRef.current = currentMap;
          },
        });
      }

      // LONG - if short was also edited, defer to next frame so the short edit's
      // transaction fully settles in changeField before we dispatch another one
      if (longChanged) {
        if (shortChanged) {
          setTimeout(() => {
            applyLongEdit();
          }, 50);
        } else {
          applyLongEdit();
        }
      }

      // Update altTextContent state with new values
      props.setAltTextContent((prev) => ({
        ...prev,
        [fileName]: {
          ...prev[fileName],
          short: editAltText.short
            ? { ...shortMeta, value: editAltText.short }
            : prev[fileName]?.short,
          long: editAltText.long
            ? { ...longMeta, value: editAltText.long }
            : prev[fileName]?.long,
          verified: prev[fileName]?.verified || false,
        },
      }));

      setAltText({ ...editAltText, shortExists: altText.shortExists, longExists: altText.longExists });
      setShowModal(false);
      setSelectedAction("");
      toastSuccess("Alt text updated successfully");
    } catch (error) {
      toastError("Error updating alt text");
    }
  };

  const getUpdatedAltText = (viewDoc) => {
    if (!viewDoc) return;

    const currentDoc = viewDoc.state.doc.toString();
    const parsed = parseLatexAltText(currentDoc);

    let finalAltText = parsed;

    if (userProfile?.role === "Master Copier") {

      const updatedAltText = { ...(props.altTextContent || {}) };

      for (const key in parsed) {

        updatedAltText[key] ??= {};

        if (parsed[key]?.short) {
          updatedAltText[key].short = {
            ...(updatedAltText[key].short || {}),
            ...parsed[key].short
          };
        }

        if (parsed[key]?.long) {
          updatedAltText[key].long = {
            ...(updatedAltText[key].long || {}),
            ...parsed[key].long
          };
        }
      }

      console.log("<<updatedAltText with preserved MC data>>", updatedAltText);

      finalAltText = updatedAltText;

      Object.keys(finalAltText).forEach((fileKey) => {
          const item = finalAltText[fileKey];
          if (item?.actionBtn) return;
          const defaultAction = item?.isEdited === true ? "validate" : "skip";
          finalAltText[fileKey] = {
            ...item,
            actionBtn: defaultAction,
          };
        });
    }

    // update state
    setAltTextMap(finalAltText);

    // keep ref synced
    altTextMapRef.current = finalAltText;

    return finalAltText;
  };

  const handleCancelEdit = () => {
    setModalMode("preview");
  };

const handleVerifyToggle = (checked) => {
  const fileName = imgPathValue?.name;
  if (!fileName) return;
 
  // update global state
  props.setAltTextContent((prev) => ({
    ...prev,
    [fileName]: {
      ...prev[fileName],
      verified: checked,
    },
  }));
 
  // update local state used by checkbox UI
  setAltTextMap((prev) => ({
    ...prev,
    [fileName]: {
      ...prev[fileName],
      verified: checked,
    },
  }));
};

  // Persist the action comment into both local and global state
  const persistComment = (comment) => {
    const fileName = imgPathValue?.name;
    if (!fileName) return;
    setAltTextMap((prev) => ({
      ...prev,
      [fileName]: { ...prev[fileName], comment },
    }));
    props.setAltTextContent((prev) => ({
      ...prev,
      [fileName]: { ...prev[fileName], comment },
    }));
  };

  const handleSaveComment = () => {
    const trimmed = validateComment.trim();
    if (!trimmed) return;
    persistComment(trimmed);
    setValidateComment(trimmed);
    setIsCommentEditing(false);
  };

  const handleCancelComment = () => {
    const saved = altTextMap[imgPathValue?.name]?.comment || "";
    setValidateComment(saved);
    // Only drop back to view mode when there is a saved comment to show
    if (saved) setIsCommentEditing(false);
  };

  const handleEditComment = () => setIsCommentEditing(true);

  const handleDeleteComment = () => {
    persistComment("");
    setValidateComment("");
    setIsCommentEditing(true);
  };

  // "Validated by MC" checkbox (Master Copier, for Create/Validate actions)
  const handleMcValidatedToggle = (checked) => {
    const fileName = imgPathValue?.name;
    if (!fileName) return;
    setAltTextMap((prev) => ({
      ...prev,
      [fileName]: { ...prev[fileName], mcValidated: checked },
    }));
    props.setAltTextContent((prev) => ({
      ...prev,
      [fileName]: { ...prev[fileName], mcValidated: checked },
    }));
  };

  const isAuthor = userProfile?.role === "Author";
  const isMC = userProfile?.role === "Master Copier";
  const isShortEmpty = !altText.shortExists;
  const isLongEmpty = !altText.longExists;
  const verifiedCount = alttextEnabled ? Object.values(props.altTextContent || {}).filter(
    (item) => item?.verified === true,
  ).length : 0;

  // Master Copier: filter list by actionBtn value
  const filteredFileList = (
    isMC && filterAction !== "all"
      ? fileList.filter(
          (item) => altTextMap[item.name]?.actionBtn === filterAction,
        )
      : [...fileList]
  ).sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }));

  const actionIconMap = { skip: skip_v2, validate: validate_v2, create: create_v2 };
  const actionLabelMap = {
    skip: "Skipped",
    validate: "Validated",
    create: "Created",
  };

  const imageTypeMap = {
  gr: "Graphical Image",
  ga: "Graphical Abstract Image",
  fx: "Inline Image",
  mmc: "Supplementary videos and gifs",
};

const getImageTitle = (name) => {
  if (!name) return "Image Preview";

  const baseName = name.split(".")[0]; // remove extension

  // extract prefix and number
  const match = baseName.match(/^([a-zA-Z]+)(\d+)$/);
  const prefix = match?.[1]?.toLowerCase();
  const number = match?.[2];

  let title = baseName;

  if (prefix === "gr") {
    title = `Fig. ${number} (${name})`;
  } else if (prefix === "sc") {
    title = `Scheme ${number}`;
  } else if (prefix === "pl") {
    title = `Plate ${number}`;
  } else {
    const fullName = imageTypeMap?.[prefix] || "";
    title = fullName ? `${fullName} (${name})` : name;
  }

  return title;
};

const AltTextInfoHint = ({ onEditClick }) => (
  <div>
    {/* Header row: "Alt Text" label + "Edit in source" button */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
      <span style={{ fontWeight: '700', fontSize: '14px' }}>Alt Text</span>
      {onEditClick && (
        <button
          onClick={onEditClick}
          // title="Jump to this image's \\alttext{} in the editor"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            padding: '5px 10px',
            fontSize: '12px',
            fontWeight: '600',
            color: '#16237a',
            backgroundColor: '#f0f3fa',
            border: '0.5px solid #6b7fd4',
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'background-color 0.15s, border-color 0.15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#dce3f5';
            e.currentTarget.style.borderColor = '#4a5ba8';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f0f3fa';
            e.currentTarget.style.borderColor = '#6b7fd4';
          }}
        >
          <FaEye style={{ width: '12px', height: '12px' }} />
          View in source
        </button>
      )}
    </div>

    {/* Read-only hint strip */}
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '7px',
      marginTop: '10px',
      marginBottom: '10px',
      padding: '7px 10px',
      backgroundColor: '#DCE1E6',
      borderLeft: '2.5px solid #a4cafe',
      borderRadius: '0 5px 5px 0',
    }}>
      <FaInfoCircle style={{ width: '13px', height: '13px', flexShrink: 0, color: '#16237a', opacity: 0.8, marginBottom: '18px' }} />
      <span style={{ fontSize: '12px', color: '#131415', lineHeight: '1.45' }}>
        <strong style={{color:'blue'}}>Note</strong> — Alt text cannot be edited here, Please update it in LaTeX source, and changes will reflect here.
      </span>
    </div>
  </div>
);

console.log("<<editAltText.short>>", editAltText)
  return (
    <section
      className="image-list-area"
      aria-labelledby="highResImageListHeading"
      style={{ position: 'relative' }}
    >
      {/* global_loader for image fetching */}
      {isImageLoading && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          height: '100%',
          width: '100%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(4px)',
          zIndex: 9999,
          borderRadius: '8px',
          padding: '30px',
          minWidth: '200px',
          minHeight: '200px'
        }}>
          <CSSLoader />
          <p style={{ marginTop: '15px', color: '#fff', fontSize: '14px' }}>Loading image...</p>
        </div>
      )}
      {Object.keys(imgPathValue).length ? (
        <div className={`modal-outer ${showModal ? "active" : ""}`}>
          <div className="modal image-refactored-modal" id="alt-text-edit" style={{ position: 'relative' }}>
            {/* Header */}
            <div
              className={
                isMC ? "new-modal-header-custom" : "modal-header-custom"
              }
            >
              <div className="modal-title">
                {getImageTitle(imgPathValue.name)}
              </div>

              {isMC && (() => {
                const handleActionChange = (action) => {
                  setSelectedAction(action);
                  const fileName = imgPathValue?.name;
                  if (!fileName) return;
                  setAltTextMap((prev) => ({
                    ...prev,
                    [fileName]: { ...prev[fileName], actionBtn: action },
                  }));
                  props.setAltTextContent((prev) => ({
                    ...prev,
                    [fileName]: { ...prev[fileName], actionBtn: action },
                  }));
                };
                return (
                  <div className="action-buttons">
                    {[
                      { value: "create", label: "Create", imgSrc: create, imgStyle: {} },
                      { value: "validate", label: "Validate", imgSrc: validate, imgStyle: { filter: "none" } },
                      { value: "skip", label: "Skip", imgSrc: skip, imgStyle: {} },
                    ].map(({ value, label, imgSrc, imgStyle }) => (
                      <label
                        key={value}
                        className={`action-btn ${selectedAction === value ? "active" : ""}`}
                      >
                        <input
                          type="radio"
                          name="altAction"
                          value={value}
                          checked={selectedAction === value}
                          onChange={(e) => handleActionChange(e.target.value)}
                        />
                        <img src={imgSrc} alt="" style={imgStyle} />
                        {label}
                      </label>
                    ))}
                  </div>
                );
              })()}
              <button
                className="close-icon-btn"
                title="Close"
                ref={modalCloseBtnRef}
                onClick={() => setShowModal(false)}
              >
                <FaTimes />
              </button>
            </div>

            {/* Body - Split Layout */}
            <div className="modal-body-custom">
              {/* Left Column: Image Area */}
              <div className="left-column">
                <div className="image-card-container">
                  {/* 
                Commenting out edit button on image as per discussion. 
                We can revisit this decision if needed in future.
                  <button
                    className="edit-image-icon-btn"
                    onClick={() => toggleEdit()}
                    title="Edit"
                  >
                    <FaEdit />
                  </button>
                */}
                  {loader ? (
                    <div className="fileupload-loder">
                      <span className="loader"></span>
                    </div>
                  ) : (
                    <div className="img-wrapper-custom">
                      <img
                        src={imgPathValue.thumbnail_base64}
                        style={
                          imgZoom > 1
                            ? {
                                width: `${imgZoom * 100}%`,
                                maxWidth: "none",
                                maxHeight: "none",
                                height: "auto",
                                margin: "auto",
                              }
                            : {
                                maxWidth: "100%",
                                maxHeight: "100%",
                                width: "auto",
                                height: "auto",
                                margin: "auto",
                              }
                        }
                        alt={imgPathValue.name?.split(".")[0]}
                        draggable={false}
                      />
                    </div>
                  )}
                </div>

                {/* Toolbar Row: High-Res, Zoom, Verified */}
                <div className="image-toolbar-row">
                  <div className="zoom-controls-group">
                    <button
                      onClick={() => handleZoom("minus")}
                      disabled={imgZoom <= 0.5}
                      title="Zoom Out"
                    >
                      <FaMinus size={12} />
                    </button>
                    <button
                      onClick={() => handleZoom("plus")}
                      disabled={imgZoom >= 3}
                      title="Zoom In"
                    >
                      <FaPlus size={12} />
                    </button>
                    <button onClick={handleResetZoom} title="Reset Zoom">
                      <FaRedo size={12} />
                    </button>
                  </div>
                  <button
                    className="view-pdf-btn"
                    title="View high-resolution PDF"
                    onClick={openPdfInNewTab}
                  >
                    View High-Res Image
                  </button>
                  {/* <div className="verified-checkbox-container">
                    <input
                      type="checkbox"
                      id="verified-chk"
                      checked={!!altTextMap[imgPathValue?.name]?.verified}
                      onChange={(e) => handleVerifyToggle(e.target.checked)}
                      disabled={!isAuthor}
                    />
                    <label htmlFor="verified-chk">Verified the Alt Text</label>
                  </div> */}
                </div>
              </div>

              {/* Right Column: Alt Text Panel (only when alttextEnabled) */}
              {alttextEnabled && <div className="right-column">
                <div className="alt-panel-top">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                    <span style={{ fontWeight: '700', fontSize: '14px' }}>Alt Text</span>
                    <button
                      onClick={handleNavigateToTeX}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        padding: '5px 10px',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#16237a',
                        backgroundColor: '#f0f3fa',
                        border: '0.5px solid #6b7fd4',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        transition: 'background-color 0.15s, border-color 0.15s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#dce3f5';
                        e.currentTarget.style.borderColor = '#4a5ba8';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#f0f3fa';
                        e.currentTarget.style.borderColor = '#6b7fd4';
                      }}
                    >
                      <FaEye style={{ width: '12px', height: '12px' }} />
                      View in source
                    </button>
                  </div>
                </div>

                <div className="alt-form-container">
                  {/* SHORT DESCRIPTION */}
                  <div
                    className={`form-group ${isShortEmpty ? "disabled-group" : ""}`}
                  >
                    <div className="label-with-badge">
                      <label>Short Description</label>

                      {!isShortEmpty && currentType.shortType && (
                        <div style={{ display: "flex", alignItems: "center", gap: "4px", }}>
                          <span
                            className={`modified-badge ${
                              currentType.shortType === "generated"
                                ? "generated"
                                : currentType.shortType === "skipped"
                                  ? "skipped"
                                  : currentType.shortType === "unmodified"
                                    ? "unmodified"
                                    : "modified"
                            }`}
                          >
                            {currentType.shortType === "generated"
                              ? "GENERATED"
                              : currentType.shortType === "skipped"
                                ? "SKIPPED"
                                : currentType.shortType === "unmodified"
                                  ? "UNMODIFIED"
                                  : "MODIFIED"}
                          </span>

                          <span
                            className="type-tooltip"
                            title={
                              currentType.shortType === "generated"
                                ? "The alt text for this image has been generated by the system."
                                : currentType.shortType === "skipped"
                                  ? "The alt text for this image has been skipped by the system."
                                  : currentType.shortType === "unmodified"
                                    ? "The alt text for this image is unmodified from the original."
                                    : "The previously provided alternative text has been revised by the system."
                            }
                          >
                            <FaInfoCircle />
                          </span>
                        </div>
                      )}
                    </div>
                      <textarea
                        className="alt-input-custom"
                        value={editAltText.short}
                        onChange={(e) =>
                          setEditAltText((prev) => ({
                            ...prev,
                            short: e.target.value,
                          }))
                        }
                        placeholder={
                          isShortEmpty
                            ? "No short description provided."
                            : "Enter short description..."
                        }
                        disabled={isShortEmpty}
                      />
                  </div>
                  {/* LONG DESCRIPTION */}
                  <div
                    className={`form-group ${isLongEmpty ? "disabled-group" : ""}`}
                  >
                    <div className="label-with-badge">
                      <label>Long Description</label>

                      {!isLongEmpty && currentType.longType && (
                        <div
                          style={{ display: "flex", alignItems: "center", gap: "4px",}}>
                          <span
                            className={`modified-badge ${
                              currentType.longType === "generated"
                                ? "generated"
                                : currentType.longType === "skipped"
                                  ? "skipped"
                                  : currentType.longType === "unmodified"
                                    ? "unmodified"
                                    : "modified"
                            }`}
                          >
                            {currentType.longType === "generated"
                              ? "GENERATED"
                              : currentType.longType === "skipped"
                                ? "SKIPPED"
                                : currentType.longType === "unmodified"
                                  ? "UNMODIFIED"
                                  : "MODIFIED"}
                          </span>

                          <span
                            className="type-tooltip"
                            title={
                              currentType.longType === "generated"
                                ? "The alt text for this image has been generated by the system."
                                : currentType.longType === "skipped"
                                  ? "The alt text for this image has been skipped by the system."
                                  : currentType.longType === "unmodified"
                                    ? "The alt text for this image is unmodified from the original."
                                    : "The previously provided alternative text has been revised by the system."
                            }
                          >
                            <FaInfoCircle />
                          </span>
                        </div>
                      )}
                    </div>

                      <textarea
                        className="alt-textarea-custom"
                        rows={6}
                        value={editAltText.long}
                        onChange={(e) =>
                          setEditAltText((prev) => ({
                            ...prev,
                            long: e.target.value,
                          }))
                        }
                        placeholder={
                          isLongEmpty
                            ? "No long description provided."
                            : "Enter long description..."
                        }
                        disabled={isLongEmpty}
                      />
                  </div>
                </div>
                <div className="alt-text-footer">
                  <div className="footer-left">
                    <div className="verified-checkbox-container">
                      <input
                        style={{ cursor: isAuthor ? "pointer" : "not-allowed", marginTop: '5px'}}
                        type="checkbox"
                        id="verified-chk"
                        checked={!!props.altTextContent?.[imgPathValue?.name]?.verified}
                        onChange={(e) => handleVerifyToggle(e.target.checked)}
                        disabled={!isAuthor}
                      />
                      <label htmlFor="verified-chk">
                        Verified the Alt Text
                      </label>
                    </div>
                  </div>
                  {(editAltText.short !== altText.short || editAltText.long !== altText.long) && (
                    <div className="modal-actions-footer">
                      <button
                        className="cancel-btn-custom"
                        onClick={() => setEditAltText({ type: editAltText.type, short: altText.short, long: altText.long })}
                      >
                        Cancel
                      </button>
                      <button
                        className="save-btn-custom"
                        onClick={handleSaveAlt}
                      >
                        Save
                      </button>
                    </div>
                  )}
                </div>
              </div>}
            </div>

            {/* Comment box — full-width footer. Shown for Master Copier for the
                Create and Validate actions. Starts in edit mode with
                Cancel/Save; once saved it shows the comment with Edit/Delete. */}
            {isMC &&
              ["create", "validate"].includes(selectedAction) && (
                <div className="validate-comment-box">
                  {/* Left 60% — Comment */}
                  <div className="comment-col">
                    <label className="comment-title" htmlFor="validate-comment">
                      <FaRegCommentDots />
                      <span>Comment</span>
                      {selectedAction === "create" && (
                        <span className="comment-required">*</span>
                      )}
                    </label>
                    {isCommentEditing ? (
                      <>
                        <textarea
                          id="validate-comment"
                          className="validate-comment-input"
                          rows={3}
                          value={validateComment}
                          placeholder="Add a comment for this image..."
                          onChange={(e) => setValidateComment(e.target.value)}
                        />
                        <div className="comment-actions">
                          <button
                            type="button"
                            className="comment-cancel-btn"
                            onClick={handleCancelComment}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="comment-save-btn"
                            onClick={handleSaveComment}
                            disabled={!validateComment.trim()}
                          >
                            <FaCheck /> Save
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="comment-saved-text">
                          {validateComment}
                        </div>
                        <div className="comment-actions">
                          <button
                            type="button"
                            className="comment-edit-btn"
                            onClick={handleEditComment}
                          >
                            <FaEdit /> Edit
                          </button>
                          <button
                            type="button"
                            className="comment-delete-btn"
                            onClick={handleDeleteComment}
                          >
                            <FaTrashAlt /> Delete
                          </button>
                        </div>
                      </>
                    )}
                  </div>

                  {/* Right 40% — Validated by MC */}
                  <div className="validated-col">
                    <p className="mc-note">
                      <FaInfoCircle />
                      <span>
                        Please confirm you have reviewed the alt text and added a
                        comment before marking it as validated.
                      </span>
                    </p>
                    <label
                      className={`mc-validated-checkbox ${
                        props.altTextContent?.[imgPathValue?.name]?.mcValidated
                          ? "checked"
                          : ""
                      }`}
                      htmlFor="mc-validated-chk"
                    >
                      <input
                        type="checkbox"
                        id="mc-validated-chk"
                        checked={!!props.altTextContent?.[imgPathValue?.name]?.mcValidated}
                        onChange={(e) => handleMcValidatedToggle(e.target.checked)}
                      />
                      <span className="mc-check-box">
                        <FaCheck />
                      </span>
                      <span>Validated by MC</span>
                    </label>
                  </div>
                </div>
              )}
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="slider-header">
        <h2 id="highResImageListHeading">{alttextEnabled ? `Image with Alt text - (${verifiedCount}/${fileList.length})` : 'Image List'}</h2>
        <div>
          <button
            className="close-btn"
            title="Close"
            tabIndex={0}
            ref={closeBtnRef}
            onClick={() => {
              setSidebarClose(true);
              // After closing, return focus to the Image tab button
              setTimeout(() => {
                const imgBtn = document.getElementById("image-tab-btn");
                if (imgBtn) imgBtn.focus();
              }, 0);
            }}
            onKeyDown={(e) => {
              // If Enter or Space, close and focus Image tab
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setSidebarClose(true);
                setTimeout(() => {
                  const imgBtn = document.getElementById("image-tab-btn");
                  if (imgBtn) imgBtn.focus();
                }, 0);
                return;
              }
              if (
                e.key === "Tab" &&
                !e.shiftKey &&
                (loader || fileList.length === 0)
              ) {
                e.preventDefault();
                const suppBtn = document.getElementById(
                  "supplementary-tab-btn",
                );
                if (suppBtn) suppBtn.focus();
              }
            }}
          >
            <FaTimes />
          </button>
        </div>
      </div>
      {alttextEnabled && isMC && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 12px", justifyContent: "space-between" }}>
          <p
            style={{
              fontSize: "12px",
              color: "#fff",
              letterSpacing: "0.3px",
              margin: 0,
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            Filter:
          </p>
          <select
            className="role-filter"
            aria-label="Role filter"
            value={filterAction}
            onChange={(e) => setFilterAction(e.target.value)}
            style={{
              fontSize: "12px",
              padding: "4px 8px",
              borderRadius: "4px",
              border: "1px solid rgba(255,255,255,0.35)",
              background: "rgba(255,255,255,0.12)",
              color: "#fff",
              cursor: "pointer",
              outline: "none",
              minWidth: 120,
              marginLeft: 45,
            }}
          >
            {[
              { value: "all", label: "All" },
              { value: "skip", label: "Skip" },
              { value: "validate", label: "Validate" },
              { value: "create", label: "Create" },
            ].map((opt) => (
              <option key={opt.value} value={opt.value} style={{ color: "#000", background: "#fff" }}>
                {opt.label}{" "}
                ({opt.value === "all"
                  ? fileList.length
                  : fileList.filter((i) => altTextMap[i.name]?.actionBtn === opt.value).length})
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="upload-list-area">
        {filteredFileList.length !== 0 ? (
          filteredFileList.map((item, index) => (
            <div
              className={`upload-list-area-inner ${
                highlightFile && item.name === highlightFile
                  ? "row-highlight"
                  : ""
              }`}
              key={index}
              style={{ display: "flex" }}
              ref={(el) => {
                if (el) rowRefs.current[item.name] = el;
              }}
            >
              <div
                className="upload-icons"
                onClick={() => openModal(item, "preview")}
                style={{ cursor: "pointer" }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") openModal(item, "preview");
                }}
              >
                <img src={image} alt="file" />
              </div>
              <div
                className="upload-details"
                onClick={() => openModal(item, "preview")}
                style={{ cursor: "pointer" }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter") openModal(item, "preview");
                  // If this is the last image, Tab should go to Supplementary tab
                  if (
                    e.key === "Tab" &&
                    !e.shiftKey &&
                    Array.isArray(filteredFileList) &&
                    index === filteredFileList.length - 1
                  ) {
                    e.preventDefault();
                    const suppBtn = document.getElementById(
                      "supplementary-tab-btn",
                    );
                    if (suppBtn) suppBtn.focus();
                  }
                }}
              >
                <p title={item.name.split(".")[0]}>{item.name.split(".")[0]}</p>
                {/* <span>Date: {moment(item.CreatedOn).format("DD MMM YY")}</span> */}
                <span>
                  Date: {moment(item.uploaded_at).format("DD MMM YY")}
                </span>
              </div>
              <div
                className="replace-icon"
                onClick={(e) => e.stopPropagation()}
                style={{ display: "flex", alignItems: "center", gap: 8 }}
              >
                {alttextEnabled && isMC && altTextMap[item.name]?.actionBtn && (
                  <img
                    src={actionIconMap[altTextMap[item.name].actionBtn]}
                    alt={actionLabelMap[altTextMap[item.name].actionBtn]}
                    title={actionLabelMap[altTextMap[item.name].actionBtn]}
                    className="file-action-icon"
                    style={{ width: 15, height: 15 }}
                  />
                )}
                {alttextEnabled && isAuthor && props.altTextContent?.[item.name]?.verified && (
                  <img
                    src={VerifiedIcon}
                    alt="Verified"
                    title="Verified"
                    className="file-action-icon"
                    style={{ width: 15, height: 15 }}
                  />
                )}
                {/* <img
                  src={EditIcon}
                  alt="Edit"
                  title="Edit"
                  className="file-action-icon"
                  style={{ width: 15, height: 15, cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    openModal(item, "edit");
                  }}
                /> */}
              </div>
            </div>
          ))
        ) : (
          <NodataFound />
        )}
        {/* <style jsx>{`
          .row-highlight {
            animation: highlight-pulse 2s ease-out;
          }
          @keyframes highlight-pulse {
            0% {
              background-color: rgba(255, 215, 0, 0.4);
            }
            100% {
              background-color: transparent;
            }
          }
        `}</style> */}
      </div>
      {/* <div className="reupload-area">
                <div className="reupload-area-inner">
                    <FaCloudUploadAlt />
                    <p>add or reupload - Choose file or drag here</p>
                    <input type="file" accept=".pdf" onChange={(e) => handleFileReupload(e)} multiple ref={fileInputRef}></input>
                </div>
            </div> */}
    </section>
  );
};
export default ImagelistTab;